import React, {useEffect, useState} from 'react';
import './AdminUserProfile.css';
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import AdminHeader from "../AdminHeader/AdminHeader";

const AdminUserProfile = () => {

    const location = useLocation();

    const navigate = useNavigate();

    const [userInfo, setUserInfo] = useState(null);

    const [isDeleted, setIsDeleted] = useState(null);

    const userId = location.state?.userId;

    useEffect(() => {
        axios.get(`/api/give_user/?id=${userId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true
        })
            .then(res => {
                setUserInfo(res.data.detail);
                if (res.data.detail.deleted_at === null) {
                    setIsDeleted(false);
                } else {
                    setIsDeleted(true);
                }
            })
            .catch(e => {
                console.log(e);
            })
    }, [setUserInfo, setIsDeleted]);

    const deleteUser = () => {
        axios.get(`/api/delete_user/?id=${userId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true
        })
            .then(res => {
                setIsDeleted(true);
                alert('Пользователь удалён');
            })
            .catch(e => {
                console.log(e);
            })
    }

    const restoreUser = () => {
        axios.get(`/api/restore_user/?id=${userId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true
        })
            .then(res => {
                setIsDeleted(false);
                alert('Пользователь восстановлен');
            })
            .catch(e => {
                console.log(e);
            })
    }

    const goBack = () => {
        navigate('/admin_user_search');
    }

    return (
        <div className={'admin-user-profile'}>
            <AdminHeader/>

            <div className={'admin-user-profile-info-and-buttons'}>
                <div className={'admin-user-profile-info'}>
                    <p className={'admin-user-profile-name'}>{userInfo?.name_user}</p>
                    <p className={'admin-user-profile-phone'}>{userInfo?.phone_number}</p>
                    <p className={'admin-user-profile-email'}>{userInfo?.email}</p>
                </div>

                <div className={`admin-user-profile-alert-button ${isDeleted ? '' : 'admin-user-profile-button-disabled'}`} onClick={() => restoreUser()}>Восстановить</div>

                <div className={`admin-user-profile-ban-button ${isDeleted ? 'admin-user-profile-button-disabled' : ''}`} onClick={() => deleteUser()}>Заблокировать</div>
            </div>

            <div className={'admin-users-back-button-container'}>
                <div className={'admin-users-back-button one-user-back-button'} onClick={() => goBack()}>Назад</div>
            </div>
        </div>
    );
};

export default AdminUserProfile;